// A phone starts on cards. Build its directory only when the table is shown,
// including a resize onto desktop; retired pages must not wake up later.
export function whenDirectoryVisible(element, table, initialize) {
  let waiting = true
  const stop = () => {
    waiting = false
    element.removeEventListener("index-view:reveal", reveal)
    window.removeEventListener("resize", reveal)
  }
  const reveal = () => {
    if (!waiting || !table.getClientRects().length) return
    stop()
    initialize()
  }
  element.addEventListener("index-view:reveal", reveal)
  window.addEventListener("resize", reveal)
  reveal()
  return stop
}
